import { Component, Input, OnInit } from '@angular/core';
import { OpenClaimRequest } from '../../shared/models/dto/open-claim-request';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { DataLayerService } from '../../core/services/dataLayer.service';
import { StepTrackerService } from '../../core/services/stepTracker.service';
@Component({
	selector: 'llamanos',
	templateUrl: './llamanos.component.html',
	styleUrls: ['./llamanos.component.scss']
})
export class LlamanosComponent implements OnInit {
	@Input() public motiveLlamanos = '';
	@Input() public submotiveLlamanos = '';
	@Input() public submotiveShown = '';

	constructor(
		private homeserveService: HomeserveService, 
		private masterService: MasterDataService,
		private dataLayerService : DataLayerService,
		private stepTrackerService : StepTrackerService
		) {}

	ngOnInit(): void {
		const openClaimReq: OpenClaimRequest = this.homeserveService.getOpenClaimRequest();
		// si ha fallado en decisionTree (entiendo que es por claimType 16, 17 y 18) rellenar motive C2C con 00016, 00017 y 00018 respectivamente
		// si falla por openClaim (entiendo que es por claimType 4) rellenar motive con error del openClaim
		openClaimReq.motivec2c = this.masterService.getLlamanosMotive();
		openClaimReq.submotivec2c = this.submotiveLlamanos;
		openClaimReq.typeCall = '3';
		this.homeserveService.openClaim(openClaimReq).subscribe((result) => {
		});
		const currentEventName = this.stepTrackerService.getCurrentEventName()
		this.dataLayerService.addDataToDataLayer({
			'event': 'modulo_hogar_cartela',
			'componentStep' :`${currentEventName}`
			
		});
		const currentStep = this.stepTrackerService.getCurrentStep();	
		this.dataLayerService.addDataToDataLayer({
			'event': 'uaevent',
			'eventCategory': 'Funnel Hogar Siniestros',
			'eventAction': 'modulo_hogar_cartela',
			'eventLabel': `Step${currentStep}`
		  });
	}
}
